import React, { useEffect } from 'react';

const Notification = ({ message, show, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000); // Automatically hide after 2 seconds
      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'linear-gradient(135deg, #ffffff, #f8f8f8)', // Subtle gradient
      color: '#333',
      padding: '20px 40px',
      borderRadius: '12px', // More rounded corners
      fontSize: '16px',
      fontWeight: 'bold', // Bold text for emphasis
      boxShadow: '0 8px 15px rgba(0, 0, 0, 0.15)', // Larger shadow for depth
      zIndex: 1000,
      maxWidth: '80%',
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif',
      border: '1px solid #ddd',
      animation: 'slide-down 0.3s ease-in-out', // Slide-in animation
      display: 'flex', // Flexbox for icon and text
      alignItems: 'center',
      gap: '10px' // Space between icon and text
    }}>
      <span style={{
        fontSize: '18px', 
        color: '#4CAF50' // Example icon color (green for success)
      }}>✓</span>
      {message}
    </div>
  );
};

export default Notification;

